import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';

import Style from '../SignInApple.module.scss';

const SignInAppleButton = ({ buttonText, handleSignIn, isConsolidatedSignUp }) => (
  <div>
    <button
      className={classNames(
        Style.signInAppleButton,
        isConsolidatedSignUp ? Style.circleIcon : null,
      )}
      onClick={handleSignIn}
    >
      <span className={Style.signInAppleButtonIcon}>
        <Icon icon="apple" color="white" size="full" />
      </span>
      {!isConsolidatedSignUp && <span className={Style.signInAppleButtonText}>{buttonText}</span>}
    </button>
    {!isConsolidatedSignUp && <div className={Style.defaultErrorGenericText} />}
  </div>
);

SignInAppleButton.propTypes = {
  isConsolidatedSignUp: PropTypes.bool,
  buttonText: PropTypes.string,
  handleSignIn: PropTypes.func,
};

export default SignInAppleButton;
